export default "__VITE_ASSET__ff3ed8a5__"